import React from 'react';
import styled from 'styled-components';
import DrawerSuccessMessages from 'components/ui/DrawerSuccessMessages';
import CtaPrimary from 'components/ui/CtaPrimary';
import CtaSecondary from 'components/ui/CtaSecondary';
import { colors } from 'helpers/ColorHelper';
import Lottie from 'react-lottie';

const defaultOptions = {
  loop: false,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const StyledButton = styled(CtaPrimary)`
  background-color: ${(props) =>
    props.disabled ? colors.LIGHT_GREY : colors.GREY_BLUE} !important;
  color: ${(props) => (props.disabled ? colors.CHAR_COUNT : colors.STATE_BLUE)} !important;
  font-size: 18px;
  font-weight: bold;
  width: 200px;
  height: 48px;
  line-height: 48px;
  margin-top: 32px;
`;

const StyledSecondaryCta = styled(CtaSecondary)`
  background-color: inherit;
  color: ${colors.STATE_BLUE};
  line-height: 36px;
  height: 36px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 28px !important;
  padding: 1px 24px 0;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: inherit;
  }
`;

const DefaultFace = ({
  onClick,
  headerText,
  bodyText,
  buttonText,
  onSecondaryClick,
  secondaryButtonText,
  animationData,
  disabled,
  loopAnimation = false,
  background,
}) => {
  const options = { ...defaultOptions, animationData: animationData, loop: loopAnimation };
  return (
    <DrawerSuccessMessages
      headerImageSource={
        <span className="chromatic-ignore">
          <Lottie options={options} height={75} width={75} />
        </span>
      }
      headerText={headerText}
      bodyText={bodyText}
      cta={
        onClick && buttonText ? (
          <StyledButton onClick={onClick} disabled={disabled}>
            {buttonText}
          </StyledButton>
        ) : null
      }
      secondaryCta={
        onSecondaryClick && secondaryButtonText ? (
          <StyledSecondaryCta onClick={onSecondaryClick}>{secondaryButtonText}</StyledSecondaryCta>
        ) : null
      }
      background={background}
    />
  );
};

export default DefaultFace;
